import { Box, Typography } from "@mui/material";
import { useCopyAndPaste } from "../../hooks/useCopyAndPaste";
import { toast } from "react-hot-toast";
import { useUserData } from "../../hooks/use-data-user";

const ReferralBanner = () => {
  const { userDataQuery } = useUserData();
  const { copy } = useCopyAndPaste();
  const handleCopy = () => {
    const baseUrl = `${process.env.REACT_APP_REWARDS}/invitation?sponsor=${userDataQuery.data?.username}&app=estate`;
    copy(baseUrl);
    toast.success("Link de referido copiado", {
      style: {
        backgroundColor: "black",
        fontWeight: "700",
        fontFamily: "Arial",
        color: "#fff",
        fontSize: "16px",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      },
    });
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: 350, sm: 600, xl: 700 },
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        backgroundImage: "url('/assets/bg-invite.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        border: "2px solid white",
        boxShadow: "0 0 12px rgba(255, 255, 255, 0.15)",
        margin: "auto",
        marginTop: { xs: 2, md: 0 },
        cursor: "pointer",
      }}
      onClick={handleCopy}
    >
      {/* Overlay difuminado */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(108, 147, 42, 0.6);",
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: { xs: 2, sm: 3 },
          [(theme) => theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          },
        }}
      >
        <Box sx={{ maxWidth: { xs: "90%", sm: "60%" } }}>
          <Typography
            variant="h5"
            fontWeight={900}
            lineHeight={1.5}
            sx={{
              color: "#fff",
              fontSize: { xs: "1rem", sm: "1.5rem" },
            }}
          >
            Invita a tus amigos a <br />
            Plusval Estate
          </Typography>
        </Box>

        <Box
          component="img"
          src="/assets/img-invite.png"
          alt="Invita a tus amigos"
          sx={{
            position: "absolute",
            bottom: 0,
            right: { xs: 80, sm: 50 },
            transform: { xs: "translateX(50%)", sm: "none" },
            height: "100%",
            maxHeight: { xs: 100, sm: 120 },
            zIndex: 2,
          }}
        />
      </Box>
    </Box>
  );
};

export default ReferralBanner;
